// Destino del ?continue= del login (y de cualquier "volver a" que venga en la URL).
//
// Solo se acepta un path del propio sitio. El parámetro lo pone cualquiera que arme el
// link, así que sin este filtro un login legítimo termina en otro sitio: "//otro.com"
// empieza con "/" y el navegador lo toma como otro dominio, y lo mismo "/\otro.com"
// (la barra invertida vale como "/") o "/<tab>/otro.com" (el tab se descarta).
//
// En vez de adivinar esos casos a mano, se resuelve la URL contra un origen fijo y se
// exige que el origen no cambie. Devuelve el path normalizado (path + query + hash).

const ORIGEN = "https://briancallimusic.com";

export function destinoSeguro(valor, porDefecto = "/portal") {
  if (typeof valor !== "string" || !valor.startsWith("/")) return porDefecto;
  try {
    const url = new URL(valor, ORIGEN);
    if (url.origin !== ORIGEN) return porDefecto;
    return url.pathname + url.search + url.hash;
  } catch {
    return porDefecto;
  }
}
